import { Theme, Typography } from "@material-ui/core";
import Box, { BoxProps } from "@material-ui/core/Box";
import { styled } from "@material-ui/styles";
import React from "react";
import InfoOutile24 from "./assets/info_outline_24px.svg";

const StyledBox = styled(Box)<Theme>(({ theme }) => ({
  color: theme.palette.turquoise.main,
  textAlign: "left",
}));

const CenteredText = styled(Typography)<Theme, HelperTextProps>(({ oneLineCentered }) => ({
  lineHeight: oneLineCentered ? "24px" : "inherit",
}));

interface HelperTextProps {
  oneLineCentered?: boolean;
}

const HelpText: React.FunctionComponent<BoxProps & HelperTextProps> = ({ children, oneLineCentered = true }) => {
  return (
    <StyledBox display="flex" p={2}>
      <Box mr={1} height="24px" fontSize="24px">
        <InfoOutile24 />
      </Box>
      <CenteredText oneLineCentered={oneLineCentered} variant="body2">
        {children}
      </CenteredText>
    </StyledBox>
  );
};

export default HelpText;
